<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="280px"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <div
        class="dialog-container"
        style="width: 280px; height: 230px;"
      >
        <div>
          <h3 class="popup-title" style="height: 60px; line-height: 60px;">비밀번호 입력</h3>
          <div class="header-btn" style="margin-right: 30px;"></div>
        </div>
        <div style="display: flex; justify-content: center;">
          <input
            type="password"
            style="width: 80%; padding: 10px; margin-top: 30px;margin-bottom: 20px; border-radius: 8px;"
            placeholder="비밀번호를 입력해주세요."
            v-model="password"
          />
        </div>
        <div class="btnArea">
          <button class="noIconButton" @click="closeDialog()">
            닫기
          </button>
          <button class="btnPrimary" @click="checkPw()">
            접속
          </button>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  components: {},
  props: ['dialog', 'meetingInfo', 'closeDialog'],
  data () {
    return {
      password: null,
    };
  },
  watch: {
    dialog: {
      handler (val) {
        this.loading = true;
      },
    },
  },
  methods: {
    async checkPw () {
      let json = {
        meetingKey: this.meetingInfo.meetingKey,
        checkDecodePw: this.password,
      };
      this.$http
        .post('/api/v1/meetings/checkDecodePw', json)
        .then((response) => {
          if (response.data.result === 'success') {
            this.$emit('joinPwMeeting');
          } else if (response.data.result === 'fail') {
            alert('비밀번호를 확인해주세요');
          }
        });
    },
  },
};
</script>
<style scoped>
.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.card-header {
  background: #efeefd;
  height: 50px;
  width: 100%;
}

.card-contents {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0 20px 0;
  font-size: 17px;
  font-weight: 500;
}
.flex-footer {
  display: flex;
  justify-content: center;
}
.dialog-okBtn {
  margin: 10px;
  width: 100px;
  background-color: #604af3;
  height: 48px;
  line-height: 48px;
  text-align: center;
  border-radius: 10px;
  color: white;
  font-size: 15px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/CheckPassword.vue